/* eslint-disable max-len */
import React, {
    useState, useContext, useCallback, useEffect
} from 'react';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { GoogleAddressLookupComponent, initializeAddressSearchViewModel } from 'gw-ext-google-tools';
import Address from '../../models/Address';
// eslint-disable-next-line import/no-unresolved

import metadata from './SasriaInsuredContactCreate.metadata.json5';
import styles from './SasriaInsuredContactCreate.module.scss';


function SasriaInsuredContactCreate(props) {
    const {
        id, onValidate, path: policySearchCriteriaVM, insuredPath: insuredContactSearchVM, claimPath: claimVM, updatePath: updateWizardData, setInsuredTypeValue: setInsuredType
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const [idType, setIdType] = useState('saId');

    const {
        isComponentValid,
        registerComponentValidation
    } = useValidation(id);

    const addressViewModel = viewModelService.create(
        new Address(),
        'cc',
        'edge.capabilities.address.dto.AddressDTO'
    );
    const [addressVM] = useState(addressViewModel);

    const getIdType = useCallback((value) => {
        if (value === 'saId') {
            _.set(insuredContactSearchVM, 'passportNumber.value', undefined);
        }
        if (value === 'passport') {
            _.set(insuredContactSearchVM, 'id.value', undefined);
        }
        setIdType(value);
    }, [insuredContactSearchVM]);

    const setDefaultValuesOnLoad = useCallback(() => {
        const searchInsuredContact = _.get(policySearchCriteriaVM.value, 'insured_EXT');
        const firstName = _.get(searchInsuredContact, 'firstName');
        const lastName = _.get(searchInsuredContact, 'lastName');
        const saId = _.get(searchInsuredContact, 'id');
        const passport = _.get(searchInsuredContact, 'passportNumber');
        _.set(insuredContactSearchVM, 'firstName.value', undefined);
        _.set(insuredContactSearchVM, 'lastName.value', undefined);
        if (passport) {
            _.set(insuredContactSearchVM, 'id.value', undefined);
        }
        if (saId) {
            _.set(insuredContactSearchVM, 'passportNumber.value', undefined);
        }
        if (firstName) {
            _.set(insuredContactSearchVM, 'firstName.value', firstName);
        }
        if (lastName) {
            _.set(insuredContactSearchVM, 'lastName.value', lastName);
        }
        if (saId) {
            setIdType('saId');
            _.set(insuredContactSearchVM, 'id.value', saId);
        } else if (passport) {
            setIdType('passport');
            _.set(insuredContactSearchVM, 'passportNumber.value', passport);
        }
        updateWizardData(claimVM);
    }, [claimVM, insuredContactSearchVM, policySearchCriteriaVM.value, updateWizardData]);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
        _.set(insuredContactSearchVM, 'insuredAddress', addressVM.value);
        setDefaultValuesOnLoad();
    }, []);

    const writeValue = useCallback(
        (value, path) => {
            _.set(insuredContactSearchVM, path, value);
            _.set(insuredContactSearchVM, 'insuredAddress', addressVM.value);
            _.set(policySearchCriteriaVM.value, 'insured_EXT', insuredContactSearchVM.value);
            setInsuredType('InsuredContact_Ext');
        },
        [insuredContactSearchVM, addressVM.value, policySearchCriteriaVM.value, setInsuredType]
    );

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },

        insuredAddressLookup: {
            model: insuredContactSearchVM,
            path: initializeAddressSearchViewModel(insuredContactSearchVM, 'insuredAddress'),
            // onValueChange: writeValue,
            label: 'Insured Location'
        },

        selectIdRadioButton: {
            value: idType
        },

        saIdInputForInsured: {
            visible: idType === 'saId'
        },

        passwordInputForInsured: {
            visible: idType === 'passport'
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getIdType: getIdType
        },
        resolveComponentMap: {
            insuredAddressLookupComponent: GoogleAddressLookupComponent
        }
    };

    const readValue = useCallback(
        (fieldId, path) => {
            return readViewModelValue(
                metadata.componentContent,
                insuredContactSearchVM,
                fieldId,
                path,
                overrideProps
            );
        },
        [insuredContactSearchVM, overrideProps]
    );

    if (_.isEmpty(insuredContactSearchVM)) {
        return null;
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={insuredContactSearchVM}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            resolveValue={readValue}
            onValueChange={writeValue}
        />
    );
}
SasriaInsuredContactCreate.propTypes = {
    id: PropTypes.string.isRequired,
    // path: PropTypes.shape({}).isRequired,
    onValidate: PropTypes.func.isRequired,
    updatePath: PropTypes.func.isRequired
};
export default SasriaInsuredContactCreate;
